import styled from 'styled-components';

export const Page = styled.div`
  width: 817px;
  height: 1057px;
  margin: auto;
  background: ${({ background }) => background || 'white'};
  padding-top: 16px;
  padding-bottom: 16px; 
  position: relative;
  padding: 20px;
  overflow: hidden;
`;

export const WatermarkText = styled.div`
  font-weight: bold;
  font-size: 9px;
  line-height: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #939AAB;
  position: absolute;
  left: 38px;
  bottom: 10px;
`;

export const ReportTypeText = styled.div`
  position: absolute;
  right: 38px;
  bottom: 10px;
  font-size: 9px;
  line-height: 13px;
  text-align: right;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #2D8BFF;
`;
